import { read, write } from './_base';
import {
  Billing_Banking_Accounts_Url,
  Billing_Banking_AccountImports_Url,
  Billing_Banking_Lines_Url,
  Billing_Banking_Line_Resolve_Url,
  Billing_Banking_Rules_Url,
} from '../../api/api.endpoints';
import {
  BankAccount,
  BankAccountsResponse,
  BankLinesResponse,
  BankRulesResponse,
} from '../../schema/billing/banking';
import { BankLineStatus } from '../../schema/billing/common';

export const listBankAccounts = () =>
  read<BankAccountsResponse>(Billing_Banking_Accounts_Url, 'Failed to load bank accounts').then((r) => r.bank_accounts ?? []);

/** Create a bank account (backend also creates its ASSET ledger account). */
export const createBankAccount = (body: { name: string; currency: string; ledger_code: string; account_number_masked?: string }) =>
  write<BankAccount>('post', Billing_Banking_Accounts_Url, { body, errorTitle: 'Could not create bank account', successTitle: 'Bank account added' });

/** Import a statement (CSV/XLSX as base64). Backend auto-matches against payments. */
export const importStatement = (
  accountId: string,
  body: { file_name: string; format: 'CSV' | 'XLSX'; content_base64: string; mapping?: { date: string; description: string; amount: string } },
) =>
  write<{ import_id: string; line_count: number; rule_matched: number; auto_matched: number; suggested: number }>(
    'post',
    Billing_Banking_AccountImports_Url(accountId),
    { body, errorTitle: 'Import failed', successTitle: 'Statement imported' },
  );

export const listBankLines = (status?: BankLineStatus) =>
  read<BankLinesResponse>(Billing_Banking_Lines_Url, 'Failed to load bank lines', status ? { status } : undefined).then((r) => r.lines ?? []);

export const listBankRules = () =>
  read<BankRulesResponse>(Billing_Banking_Rules_Url, 'Failed to load rules').then((r) => r.rules ?? []);

export const resolveBankLine = (id: string, body: { type: 'match'; payment_id: string } | { type: 'ignore' }) =>
  write('post', Billing_Banking_Line_Resolve_Url(id), { body, errorTitle: 'Could not resolve line', successTitle: body.type === 'match' ? 'Line reconciled' : 'Line ignored' });
